import { useEffect, useState } from 'react';

/**
 * Returns a value that updates only after `delay` ms have passed since the most recent
 * change. Standard pattern for keystroke-driven queries; centralised here so we don't
 * re-implement the timer dance in every feature (M-A10).
 *
 * Defaults to 300 ms per CLAUDE.md frontend guidance.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    return debounced;
}
